// extracted by mini-css-extract-plugin
module.exports = {"container":"DisplayBrowser_container__3s6ow"};